import { gql } from "apollo-boost";
import { apolloClient, getApolloOptions } from "./apolloClient";

const GET_EXPERIENCES = gql`
  query {
    experiences(sort: "name"){
      id
      name
      code
      flexible
      min_number_of_players
      max_number_of_players
      config
      duration
      application {
        type_for_xcube
        type_for_xpod
        type_for_xkiosk
        type_for_xtend
      }
    }
  }
`;

const GET_EXPERIENCE = gql`
  query Experience($id: ID!){
    experience(id: $id) {
      id
      name
      code
      flexible
      min_number_of_players
      max_number_of_players
      config
      duration
      application {
        type_for_xcube
        type_for_xpod
        type_for_xkiosk
        type_for_xtend
      }
    }
  }
`;

const GET_XCUBE_EXPERIENCES = gql`
  query ($limit: Int, $offset: Int, $experienceId: ID!) {
    xCubeExperiences(
      where: { experience: { id: $experienceId } }
      limit: $limit
      start: $offset
      sort: "id:asc"
    ) {
      id
      status
      xcube {
        id
        name
      }
    }
  }
`;

// const GET_EXPERIENCES_FOR_DEVICE = gql`
//   query ($xcubeID: ID!) {
//     xCubeExperiences(
//       where: { xcube: { id: $xcubeID }, status: "on" }
//       sort: "experience.name:asc"
//     ) {
//       id
//       status
//       experience {
//         name
//         id
//         config
//       }
//     }
//   }
// `;

const GET_INSTALLED_EXPERIENCES_FOR_DEVICE = gql`
  query ($xcubeID: ID!) {
    xCubeApplications(
      where: { x_cube: { id: $xcubeID }, status: "active" }
    ) {
      id
      status
      application {
        experiences {
            name
            id
            config
            duration
            max_number_of_players
            min_number_of_players
        }
      }
    }
  }
`;

const GET_FLEXIBLE_EXPERIENCES = gql`
  query {
    experiences(
      where: { flexible: true }
    ) {
        name
        id
        config
        duration
    }
  }
`;

const UPDATE_XCUBE_EXPERIENCE_STATUS = gql`
    mutation ($id: ID!, $status: ENUM_XCUBEEXPERIENCE_STATUS!) {
        updateXCubeExperience(
            input: {
                where: { id: $id }
                data: { status: $status }
            }
        ) {
            xCubeExperience {
                id
                status
            }
        }
    }
`;

export const CREATE_XCUBE_EXPERIENCE_STATUS = gql`
    mutation ($xcubeId: ID!, $experienceId: ID!, $status: ENUM_XCUBEEXPERIENCE_STATUS!) {
        createXCubeExperience(
            input: {
                data: {
                    xcube: $xcubeId
                    experience: $experienceId
                    status: $status
                }
            }
        ) {
            xCubeExperience {
                id
                status
            }
        }
    }
`;

export const createXCubeExperienceStatus = async (xcubeId, experienceId, status) => {
    try {
        const res = await apolloClient.mutate({
            ...getApolloOptions(),
            mutation: CREATE_XCUBE_EXPERIENCE_STATUS,
            variables: { xcubeId, experienceId, status },
        });
        return res.data.createXCubeExperience.xCubeExperience;
    } catch (error) {
        console.error("Error creating XCube Experience status:", error);
        return null;
    }
};

export const updateXCubeExperienceStatus = async (xcubeExperienceId, status) => {
    try {
        const res = await apolloClient.mutate({
            ...getApolloOptions(),
            mutation: UPDATE_XCUBE_EXPERIENCE_STATUS,
            variables: { id: xcubeExperienceId, status },
        });
        return res.data.updateXCubeExperience.xCubeExperience;
    } catch (error) {
        console.error("Error updating XCube Experience status:", error);
        return null;
    }
};


export const getExperiencesSimple = async () => {
    const res = await apolloClient.query({
        ...getApolloOptions(),
        query: GET_EXPERIENCES,
    });
    return res.data.experiences;
};

export const getInstalledExperiencesForDevice = async (id) => {
    const res = await apolloClient.query({
        ...getApolloOptions(),
        variables: { xcubeID: id },
        query: GET_INSTALLED_EXPERIENCES_FOR_DEVICE,
    });
    return res.data.xCubeApplications;
}

export const getFlexibleExperiences = async () => {
    const res = await apolloClient.query({
        ...getApolloOptions(),
        query: GET_FLEXIBLE_EXPERIENCES,
    });
    return res.data.experiences;
};

export const getExperienceSimple = async (id) => {
    const res = await apolloClient.query({
        ...getApolloOptions(),
        query: GET_EXPERIENCE,
        variables: { id },
    });
    return res.data.experience;
};

export const getXCubeExperiences = async (experienceId) => {
    let result = [];
    let offset = 0;
    let page = [];
    do {
        const res = await apolloClient.query({
            ...getApolloOptions(),
            query: GET_XCUBE_EXPERIENCES,
            variables: { limit: 100, offset: offset, experienceId },
        });
        page = res.data.xCubeExperiences;
        result = result.concat(page);
        offset += 100;
    } while (page.length === 100);

    return result;
}
